import React, {useEffect} from "react";
import {observer} from "mobx-react";
import styled from "styled-components";
import {Button, Col, Form, Input, message, Row} from "antd";
import {useStore} from "../../store";
import {editBaseLibraryInfoApi} from "../../http/manager";

interface BaseLibraryEditModalProps {
    onSuccess?:() => void;
}

const BaseLibraryEdit:React.FC<BaseLibraryEditModalProps> = ({onSuccess}) => {

    const [form] = Form.useForm();
    const {baseLibraryStore} = useStore();

    useEffect(() => {
        form.setFieldsValue(baseLibraryStore.showBaseLibraryDetail)
    },[])

    const submit = () => {
        console.log("dtl----", form.getFieldsValue(true))
        const params = new FormData();
        const fieldValue = form.getFieldsValue(true);
        params.set("speciesZhName", fieldValue.speciesZhName);
        params.set("canonicalName", fieldValue.canonicalName);
        params.set("speciesAuthor", fieldValue.speciesAuthor);
        params.set("genus", fieldValue.genus);
        params.set("speciesClass", fieldValue.speciesClass);
        params.set("speciesOrder", fieldValue.speciesOrder);
        params.set("speciesFamily", fieldValue.speciesFamily);
        params.set("speciesFamilyName", fieldValue.speciesFamilyName);
        params.set("genusName", fieldValue.genusName);
        params.set("species", fieldValue.species);
        params.set("id", fieldValue.id);

        editBaseLibraryInfoApi(params)
            .then((res) => {
                if (Number(res.code) === 200) {
                    message.success("编辑成功");
                    if (onSuccess) {
                        onSuccess();
                    }
                } else {
                    message.error("编辑失败");
                }
            }).catch(() => {
                message.error("编辑失败");
        })
    }

    return(<Wrapper>
        <Form labelAlign={"right"} wrapperCol={{span:"15"}} title={"基础库编辑"} form={form} layout={"horizontal"} size={"middle"} style={{maxHeight: "400px", overflow: "hidden"}}>
            <Row justify={"space-between"} gutter={[15, 15]}>
                <Col span={12}><Form.Item labelCol={{span:"8"}} label={"物种中文名"} name={"speciesZhName"} required={true}><Input/></Form.Item></Col>
                <Col span={12}><Form.Item labelCol={{span:"8"}} label={"物种拉丁文"} name={"canonicalName"} required={true}><Input/></Form.Item></Col>
                <Col span={12}><Form.Item labelCol={{span:"8"}} label={"物种采集人"} name={"speciesAuthor"} required={true}><Input/></Form.Item></Col>
                <Col span={12}><Form.Item labelCol={{span:"8"}} label={"属"} name={"genus"} required={true}><Input/></Form.Item></Col>
                <Col span={12}><Form.Item labelCol={{span:"8"}} label={"纲"} name={"speciesClass"} required={true}><Input/></Form.Item></Col>
                <Col span={12}><Form.Item labelCol={{span:"8"}} label={"目"} name={"speciesOrder"} required={true}><Input/></Form.Item></Col>
                <Col span={12}><Form.Item labelCol={{span:"8"}} label={"科"} name={"speciesFamily"} required={true}><Input/></Form.Item></Col>
                <Col span={12}><Form.Item labelCol={{span:"8"}} label={"科中文名"} name={"speciesFamilyName"} required={true}><Input/></Form.Item></Col>
                <Col span={12}><Form.Item labelCol={{span:"8"}} label={"属中文名"} name={"genusName"} required={true}><Input/></Form.Item></Col>
                <Col span={12}><Form.Item labelCol={{span:"8"}} label={"种加词"} name={"species"} required={true}><Input/></Form.Item></Col>
            </Row>
        </Form>
        <Button onClick={submit} style={{marginTop: "30px"}} type={"primary"}>提交</Button>
    </Wrapper>);
}

export default observer(BaseLibraryEdit)

const Wrapper = styled.div`
  & {
    display: flex;
    flex-direction: column;
    padding: 20px 0 20px 0;
  }  
`;